import { BREAKPOINTS } from "../../../constants/design";
import { Device } from "../../../constants/device";
import useMediaWithDevice from "../../../hooks/use-media-with-device";
export var useIsMobileMenu = function useIsMobileMenu() {
  var isMd = useMediaWithDevice("(max-width: ".concat(BREAKPOINTS.md - 1, "px)"), Device.Mobile);
  return isMd;
};